var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusicButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Music",
    clipPath: "url(#clip0_10052_18798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.637706 16.6957C0.337706 16.6957 0.0932617 16.4512 0.0932617 16.1512V7.81788C0.0932617 7.51788 0.337706 7.27344 0.637706 7.27344C0.937706 7.27344 1.18215 7.51788 1.18215 7.81788V16.1512C1.18215 16.4512 0.937706 16.6957 0.637706 16.6957Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.93775 20.6828C3.63775 20.6828 3.39331 20.4384 3.39331 20.1384V3.8628C3.39331 3.5628 3.63775 3.31836 3.93775 3.31836C4.23776 3.31836 4.4822 3.5628 4.4822 3.8628V20.1384C4.4822 20.4384 4.23776 20.6828 3.93775 20.6828Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.15113 23.956C6.85113 23.956 6.60669 23.7116 6.60669 23.4116V0.589366C6.60669 0.289366 6.85113 0.0449219 7.15113 0.0449219C7.45113 0.0449219 7.69558 0.289366 7.69558 0.589366V23.4116C7.69558 23.7116 7.45113 23.956 7.15113 23.956Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.6665 16.6957C13.3665 16.6957 13.1221 16.4512 13.1221 16.1512V7.81788C13.1221 7.51788 13.3665 7.27344 13.6665 7.27344C13.9665 7.27344 14.211 7.51788 14.211 7.81788V16.1512C14.211 16.4512 13.9665 16.6957 13.6665 16.6957Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.3643 20.6828C10.0643 20.6828 9.81982 20.4384 9.81982 20.1384V3.8628C9.81982 3.5628 10.0643 3.31836 10.3643 3.31836C10.6643 3.31836 10.9087 3.5628 10.9087 3.8628V20.1384C10.9087 20.4384 10.6643 20.6828 10.3643 20.6828Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.8489 23.956C16.5489 23.956 16.3044 23.7116 16.3044 23.4116V0.589366C16.3044 0.289366 16.5489 0.0449219 16.8489 0.0449219C17.1489 0.0449219 17.3933 0.289366 17.3933 0.589366V23.4116C17.3933 23.7116 17.1489 23.956 16.8489 23.956Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.3623 16.6957C23.0623 16.6957 22.8179 16.4512 22.8179 16.1512V7.81788C22.8179 7.51788 23.0623 7.27344 23.3623 7.27344C23.6623 7.27344 23.9068 7.51788 23.9068 7.81788V16.1512C23.9068 16.4512 23.6623 16.6957 23.3623 16.6957Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M20.0623 20.6828C19.7623 20.6828 19.5178 20.4384 19.5178 20.1384V3.8628C19.5178 3.5628 19.7623 3.31836 20.0623 3.31836C20.3623 3.31836 20.6067 3.5628 20.6067 3.8628V20.1384C20.6067 20.4384 20.3623 20.6828 20.0623 20.6828Z"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10052_18798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicButton);
export default __webpack_public_path__ + "static/media/MusicButton.14d67f70a99bc226ba18cf86c6079115.svg";
export { ForwardRef as ReactComponent };